<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="openAdd()">新增</el-button>
      <!--      <el-date-picker v-fixZoom class="datePicker-query" :clearable="false" v-model="selectDate" type="date"-->
      <!--                      value-format="yyyy-MM-dd" placeholder="请选择日期" :picker-options="pickerOptions" style="margin-right: 5px; width: 200px">-->
      <!--      </el-date-picker>-->
      <!--      <el-button type="success" @click="getSearchData">查询</el-button>-->
    </div>
    <div style="height: calc(100% - 120px);margin: 0 20px">
      <el-table class="dayworktable" :data="tableData" border ref="singleTable" height="100%">
        <el-table-column type="index" label="序号" width="70" align="center">
        </el-table-column>
        <el-table-column prop="respondent_name" label="填写人" min-width="100" align="center">
        </el-table-column>
        <el-table-column prop="survey_date" label="时间" min-width="120" align="center">
        </el-table-column>
        <el-table-column label="满意程度" width="300" align="center">
          <template slot-scope="scope">
            <div style="width: 100%;height: 30px">
              <div style="float: left;width: 90px;text-align: right;margin-right: 10px">服务内容</div>
              <div style="float: left"><el-rate :disabled="true" v-model="scope.row.service_rating"></el-rate></div>
            </div>
            <div style="width: 100%;height: 30px">
              <div style="float: left;width: 90px;text-align: right;margin-right: 10px">体验感</div>
              <div style="float: left"><el-rate :disabled="true" v-model="scope.row.experience_rating"></el-rate></div>
            </div>
            <div style="width: 100%;height: 30px">
              <div style="float: left;width: 90px;text-align: right;margin-right: 10px">安全性</div>
              <div style="float: left"><el-rate :disabled="true" v-model="scope.row.safety_rating"></el-rate></div>
            </div>
            <div style="width: 100%;height: 30px">
              <div style="float: left;width: 90px;text-align: right;margin-right: 10px">便捷度</div>
              <div style="float: left"><el-rate :disabled="true" v-model="scope.row.convenience_rating"></el-rate></div>
            </div>
            <div style="width: 100%;height: 30px">
              <div style="float: left;width: 90px;text-align: right;margin-right: 10px">餐饮及卫生</div>
              <div style="float: left"><el-rate :disabled="true" v-model="scope.row.canteen_rating"></el-rate></div>
            </div>
            <div style="width: 100%;height: 30px">
              <div style="float: left;width: 90px;text-align: right;margin-right: 10px">智慧养老整体满意度</div>
              <div style="float: left"><el-rate :disabled="true" v-model="scope.row.support_rating"></el-rate></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="notes" label="反馈" min-width="120" align="center"></el-table-column>
        <el-table-column label="图片" min-width="120" align="center">
          <template slot-scope="scope">
            <img v-if="scope.row.photo_path"
                 :src="scope.row.photo_path"
                 style="width: 90px;height: 90px;cursor: pointer;"
                 @click="showImage(scope.row.photo_path)" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="openEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" plain @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="600px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ titleShow }}</span>
        <div class="line-title"></div>
      </div>
      <addEditBack :surveyObj="surveyObj" v-model="addEditShow" @updateTable="updateTable"></addEditBack>
    </el-dialog>
    <el-dialog :visible.sync="imagePreview.visible" v-if="imagePreview.visible" width="600px" center class="all-open">
      <div style="width: 100%;text-align: center;padding: 10px">
        <img :src="imagePreview.url" style="max-width: 100%" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import addEditBack from './components/addEditBack.vue'
import addEditServiceRecord from './components/addEditServiceRecord.vue'
import {getsurveylist, deletesurvey} from '../../api/yanglaoyuan'
export default {
  name: 'oldFeedBack',
  components: {addEditServiceRecord, addEditBack},
  data () {
    return {
      entityId: 0,
      selectDate: '',
      pickerOptions: {
        shortcuts: []
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,

      tableData: [],
      addEditShow: false,
      titleShow: '',
      surveyObj: {
        isAdd: true,
        respondent_type: 2,
        row: ''
      },
      imagePreview: {
        visible: false,
        url: ''
      }
    }
  },
  created () {
    let loginResp = this.$store.state.user.LoginResp
    this.entityId = loginResp.entity_id
    this.getFeedbackData()
  },
  methods: {
    showImage (url) {
      this.imagePreview.url = url
      this.imagePreview.visible = true
    },
    openAdd () {
      this.titleShow = '新增反馈'
      this.surveyObj.row = ''
      this.surveyObj.isAdd = true
      this.addEditShow = true
    },
    getSearchData () {
      this.getFeedbackData()
    },
    updateTable () {
      this.getFeedbackData()
    },
    getFeedbackData () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.entityId,
        respondent_type: 2
      }
      getsurveylist(params, data).then(res => {
        this.tableData = res.data.arrdata
        this.totalCells = res.data.cnt
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getFeedbackData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getFeedbackData()
    },
    openEdit (row) {
      this.titleShow = '修改反馈'
      this.surveyObj.row = row
      this.surveyObj.isAdd = false
      this.addEditShow = true
    },
    del (row) {
      this.$confirm('此操作将删除该反馈, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletesurvey(data).then(res => {
          this.$notify({title: '成功', message: '成功删除该护理记录', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.page > 1) {
            this.page = this.page - 1
          }
          this.getFeedbackData()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/oldFeedBack.vue